import Contact from '../../components/contact/Contact';
import Header from '../../components/header/header';

const ContactUs = () => {
	return (
		<main>
            <Header pageTitle={`Contact Us`} />
			<Contact />	
		</main>
	);
};

export default ContactUs;
